<template>

  <div class="product-add pb50">
   <!--添加课程-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加课程</div>


      <el-form-item label="课程分类">
        <el-select v-model="form.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in catgory" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>



      <el-form-item label="课程标题" prop="material_title">
        <el-input type="text" v-model="form.material_title" autocomplete="off" placeholder="请输入课程标题" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="课程副标" prop="material_p">
        <el-input type="text" v-model="form.material_p" autocomplete="off" placeholder="请输入课程副标" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="课程标签" prop="labels">
        <el-input type="input" v-model="form.labels" autocomplete="off" placeholder="请输入标签" class="max-w460"></el-input>
         <div class="gray">多个标签，空格隔离；如：111 222 333</div>
      </el-form-item>

      <el-form-item label="排序">
        <el-input type="number" v-model="form.material_sort" placeholder="请输入数字" class="max-w460"></el-input>
        <div class="gray">数字越小越靠前</div>
      </el-form-item>


      <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.material_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item label="课程类型：" :rules="[{ required: true, message: '课程类型' }]" prop="material_type">
        <el-radio-group v-model="form.material_type">
          <el-radio :label="10">图文</el-radio>
          <el-radio :label="20">视频</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="课程图片：" :rules="[{ required: true, message: '请上传课程图片' }]" prop="image" v-if="form.material_type == 10">
        <div slot="label">课程图片：<gm-tips content="建议尺寸750x400" /></div>
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div class="item" v-for="item in form.image" :key="item.file_path">
                <img v-img-url="item.file_path" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(item)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
      <el-form-item label="课程视频" v-if="form.material_type == 20">
        <div>
          <el-button type="primary" @click="openVideoUpload">上传视频</el-button>
          <video :src="videopath" class="mt10" width="120px;" height="120px" v-if="isVideo" :isVideo="isVideo" controls="controls" style="display: block;" />
          <!--上传图片组件-->
          <Video v-if="isvideoupload" :config="{ total: 1 }" :isvideoupload="isvideoupload" @returnImgs="returnVideoFunc">上传视频</Video>
        </div>
      </el-form-item>


     <!-- <el-form-item label="列表横图" prop="imagerow">
        <div slot="label">列表横图：<gm-tips content="建议尺寸350x190" /></div>
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploadrow({ type: 'imagerow' })">选择图片
          </el-button>
          <div class="draggable-list">
            <div v-if="form.imagerow !== ''" class="img item">
              <img :src="form.imagerow" width="100" height="100" alt="imagerow"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImagerow"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item> -->

      <el-form-item label="海报图片" prop="imagead">
        <div slot="label">海报图片：<gm-tips content="建议尺寸750x750" /></div>
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploadad({ type: 'imagead' })">选择图片
          </el-button>
          <div class="draggable-list">
            <div v-if="form.imagead !== ''" class="img item">
              <img :src="form.imagead" width="100" height="100" alt="imagead"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImagead"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item>


      <el-form-item label="转发图片" prop="imageshare">
        <div slot="label">转发图片：<gm-tips content="建议尺寸500x400" /></div>
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploadshare({ type: 'imageshare' })">选择图片
          </el-button>
          <div class="draggable-list">
            <div v-if="form.imageshare !== ''" class="img item">
              <img :src="form.imageshare" width="100" height="100" alt="imageshare"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImageshare"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item>



      <!--内容-->
      <el-form-item label="课程详情">
        <div class="d-s-c">
          <div class="edit_container">
            <Uediter :text="form.dec" :config="ueditor.config" ref="ue"></Uediter>
          </div>

        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>


    <!--上传图片组件-->
    <Upload v-if="isuploadrow" :isupload="isuploadrow" type="image" @returnImgs="returnImgsrow">上传图片</Upload>
    <Upload v-if="isuploadad" :isupload="isuploadad" type="image" @returnImgs="returnImgsad">上传图片</Upload>
    <Upload v-if="isuploadshare" :isupload="isuploadshare" type="image" @returnImgs="returnImgsshare">上传图片</Upload>


  </div>
</template>

<script>
import MaterialApi from '@/api/material2.js';
import Upload from '@/components/file/Upload';
import Video from '@/components/file/Video';
import draggable from 'vuedraggable';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    Video: Video,
    /*图片上传*/
    Upload: Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否打开产品弹出层*/
      isproduct: false,
      /*是否上传图片*/
      isupload: false,
      isvideoupload:false,
      isImg: false,
      isVideo: false,

      isProductUpload: false,
      isuploadrow: false,
      isuploadad: false,
      isuploadshare: false,

      path: '',
      videopath: '',
      /*form表单数据*/
      form: {
        mtype:2,
        product_id:0,
        nickName:'',
        material_title: '',
        material_p: '',
        labels:'',
        category_id: '',
        product_id: '',
        image_id: '',
        video_id:'',
        avatar:"",
        material_sort: 1,
        material_status: 1,
        virtual_views: 1,
        image: [],
        imagerow:'',
        imagead:'',
        imageshare:'',
        dec: '',
        material_type:10,
      },
      product:{},
      /*课程类别*/
      catgory: [],
      loading: false,
      /*验证规则*/
      rules: {
        material_title: [{ required: true, message: '请输入课程标题', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入发布人昵称', trigger: 'blur' }],
      },

      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },

    };
  },

  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(e) {
      for (var i = 0; i < this.form.image.length; i++) {
        if (e.file_id == this.form.image[i].file_id) {
          this.form.image.splice(i, 1);
        }
      }
    },
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.avatar = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*上传视频*/
    openVideoUpload() {
      this.isvideoupload = true;
    },

    /*获取视频*/
    returnVideoFunc(e) {
      let self = this;
      if (e != null) {
        this.form.video_id = e[0].file_id;
        this.videopath = e[0].file_path;
        this.isVideo = true;
      }
      this.isvideoupload = false;
    },
    /*获取课程类别*/
    getCategoryList() {
      let self = this;
      let Params = {};

      MaterialApi.toAddMaterial(Params, true)
        .then(res => {
          self.catgory = res.data.catgory;
          if(self.catgory.length > 0){
            self.form.category_id = self.catgory[0].category_id;
          }
        })
        .catch(error => {

        });
    },

    /*添加课程*/
    onSubmit() {
      let self = this;
      let form = self.form;
      form.dec = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          MaterialApi.materialAdd(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/material2/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回课程列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/material2/index'
      });
    },
    /*删除商品*/
    deleteFunc() {
      this.form.product_id = 0;
      this.product = {};
    },

    /*产品列表弹出层*/
    openProduct() {
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      this.isproduct = e.openDialog;
      console.log(e)
      if (e.type == 'success') {
        this.form.product_id = e.params.product_id;
        this.product = e.params;
      }
    },






    //列表横图
    openUploadrow(e) {
      this.isuploadrow = true;
    },
    deleteImagerow() {
      this.form.imagerow = "";
      this.isuploadrow = false;
    },
    returnImgsrow(e) {
      if (e != null && e.length > 0) {
        this.form.imagerow = e[0].file_path;
      }
      this.isuploadrow = false;
    },


    //海报图片
    openUploadad(e) {
      this.isuploadad = true;
    },
    deleteImagead() {
      this.form.imagead = "";
      this.isuploadad = false;
    },
    returnImgsad(e) {
      if (e != null && e.length > 0) {
        this.form.imagead = e[0].file_path;
      }
      this.isuploadad = false;
    },


  //转发图片
    openUploadshare(e) {
      this.isuploadshare = true;
    },
    deleteImageshare() {
      this.form.imageshare = "";
      this.isuploadshare = false;
    },
    returnImgsshare(e) {
      if (e != null && e.length > 0) {
        this.form.imageshare = e[0].file_path;
      }
      this.isuploadshare = false;
    },


  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/material2/material/add.vue